// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

$.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
import Modal from 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';

//Load Modules
import './modules/accordion';
import './modules/animatein';
import './modules/bannerVideo';
import './modules/formInputs';
import './modules/gravityForms'; // only include if using WordPress Gravity plugin
import './modules/videoButtonReplacer';
import './modules/videoPlay';
import './modules/menu';
import './modules/modal';
import './modules/scrollTo';
import './modules/searchToggle';
import './modules/shareSocial';
import './modules/sideMenu';
import './modules/sliders';
import './modules/alert';
import './modules/handlebars';
import { initVideoPopup } from './modules/videoPopup';
initVideoPopup(Modal);
